import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismReveal } from './components/MechanismReveal';
import { ObjectionHandlers } from './components/ObjectionHandlers';
import { WhatIncludes } from './components/WhatIncludes';
import { WhoIsFor } from './components/WhoIsFor';
import { ResultsSection } from './components/ResultsSection';
import { PricingCTA } from './components/PricingCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-[#1C1C2E] min-h-screen text-[#F5F0E8] overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <MechanismReveal data-id="element-4" />
      <ObjectionHandlers data-id="element-5" />
      <WhatIncludes data-id="element-6" />
      <WhoIsFor data-id="element-7" />
      <ResultsSection data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <FloatingCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}